import { Capacitor } from "@capacitor/core";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD4eFpzBvh8zRRupL3mjlDwjTmrCM9s6OM",
  authDomain: "presentplus-prod.firebaseapp.com",
  projectId: "presentplus-prod",
  storageBucket: "presentplus-prod.firebasestorage.app",
  messagingSenderId: "481337212083",
  appId: "1:481337212083:web:4ecf3670f30d8e9b84c4c6",
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const isNativeApp = Capacitor.isNativePlatform();

const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const appCheckEnabled = process.env.REACT_APP_ENABLE_APP_CHECK === "true";

if (!isNativeApp && appCheckEnabled && appCheckSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

let authInstance;

try {
  authInstance = initializeAuth(app, {
    persistence: indexedDBLocalPersistence,
  });
} catch (err) {
  authInstance = getAuth(app);
}

export const auth = authInstance;
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west2");
export const storage = getStorage(app);

export let messaging = null;

if (!isNativeApp && typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) messaging = getMessaging(app);
    })
    .catch(() => {
      messaging = null;
    });
}